<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div id="defaultId1 " style="padding-bottom: 20px" v-loading="RiskLoding">
    <div id="g2ede8" class="operations-content">
      <div
        id="gfff13"
        class="trade_midlle_bottom_cont mt0"
        v-if="markTotalList.length > 0"
        v-show="false"
      >
        <div
          v-for="(item, index) in markTotalList"
          :key="index"
          style="flex: 1"
        >
          <gui_mark_total
            :isTradeProduct="true"
            :MoudeImg="'images/tradejiugonge.png'"
            id="g9eda6"
            class="trade_midlle_bottom_item"
            :label="item.name"
            :total="item.num"
            v-if="item.num != '-'"
          >
          </gui_mark_total>
        </div>
      </div>

      <div class="operations-head-content">
        <h2 id="gf7b16" class="operations-head detail_title_20">
          {{ $t("SearchTrade.OverviewofSupplyChainInformation") }}
        </h2>

        <div id="g8b81a" @click="activeIcon = !activeIcon" class="Information">
          <svg
            id="idex5xpV"
            class="icon"
            t="1718690711396"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4563"
            width="2.57rem"
            height="2.57rem"
          >
            <path
              id="id3aCJoQ"
              d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
              :fill="activeIcon ? '#009EA7' : '#8497AB'"
              p-id="4564"
            ></path>
          </svg>
        </div>
      </div>
      <div class="Product_Supply_select flex_center_bettwen">
        <div class="">
          <el-select
            style="width: 27.857143rem"
            @change="ChangCountry"
            v-model="Importyear"
            :placeholder="$t('SearchTrade.PleaseSelect')"
          >
            <el-option
              v-for="(item, index) in Yearoptions"
              :disabled="!item.hasData"
              :key="index"
              :label="item.year"
              :value="item.year"
            >
            </el-option>
          </el-select>
          <el-select
            filterable=""
            @change="getData()"
            style="width: 27.857143rem; margin-left: 20px"
            v-model="Country"
            :placeholder="$t('SearchTrade.PleaseSelect')"
          >
            <el-option
              v-for="(item, index) in Countryoptions"
              :key="index"
              :label="item.countryName"
              :value="item.countryCode"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          style="background-color: #009ea7 !important"
          class="btn_export"
          @click="getProductSupplyChainFilterYear"
        >
          {{ $t("SearchTrade.Reset") }}</el-button
        >
      </div>

      <div class="detail_echart_con">
        <div class="detail_echart_con_box">
          <div class="ownership-graph-left">
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("SearchTrade.ImportCountries") }}
              </div>
              <div class="ownership-graph-left-desc">
                {{ ImportCountries }}
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("SearchTrade.ExportCountries") }}
              </div>
              <div class="ownership-graph-left-desc">
                {{ ExportCountries }}
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">{{ $t("SearchTrade.ImportCompanyTop") }}</div>
              <div class="ownership-graph-left-desc">
                <span
                  :class="TopImportCompany == '' ? '' : 'CountryActive'"
                  @click="exportCompanyImport(TopImportCompany)"
                >
                  {{
                    TopImportCompany.value == "" ? "-" : TopImportCompany.value
                  }}
                </span>
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">{{ $t("SearchTrade.ExportCompanyTop") }}</div>
              <div class="ownership-graph-left-desc">
                <span
                  :class="TopExportCompany == '' ? '' : 'CountryActive'"
                  @click="exportCompanyImport(TopExportCompany)"
                >
                  {{
                    TopExportCompany.value == "" ? "-" : TopExportCompany.value
                  }}
                </span>
              </div>
            </div>
          </div>

          <div class="operations-box">
            <div
              ref="SupplyChainEchart"
              style="width: 100%; height: 642px"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div id="g2ede8" class="operations-content margin-top10" v-if="activeIcon">
      <h2 id="gf7b16" class="operations-head detail_title_20">
        {{ $t("SearchTrade.OriginInformationOverview") }}
      </h2>

      <div class="table-biao margin-top20">
        <el-table
          :data="countryOfImporter"
          ref="table"
          empty-text="No Data"
          style="width: 100%"
          class="table_height_30 table_font_size_14 table_contentHeight_40"
        >
          <el-table-column align="left" label=" # " show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="countryOfImporter"
            :label="$t('SearchTrade.Origin')"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.countryOfImporter }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="transactions"
            :label="$t('SearchTrade.Transactions')"
            width="280"
            align="left"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.transactions | FilterNum }}</span>
              <!-- </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div id="g2ede8" class="operations-content margin-top10" v-if="activeIcon">
      <h2 id="gf7b16" class="operations-head detail_title_20">
        {{ $t("SearchTrade.DestinationInformationOverview") }}
      </h2>

      <div class="table-biao margin-top20">
        <el-table
          :data="countryOfSupplier"
          ref="table"
          :empty-text="$t('SearchTrade.NoData')"
          style="width: 100%"
          class="table_height_30 table_font_size_14 table_contentHeight_40"
        >
          <el-table-column align="left" show-overflow-tooltip label=" # ">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="countryOfSupplier"
            :label="$t('SearchTrade.Destination')"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.countryOfSupplier }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="transactions"
            :label="$t('SearchTrade.Transactions')"
            width="280"
            align="left"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.transactions | FilterNum }}</span>
              <!-- </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import {
  getProductSupplyChain,
  getProductSupplyChainFilter,
  getProductSupplyChainTopTenCountries,
} from "@/api/companyApi.js";
import ReLogin from "../../../../components/ReLogin.vue";
import {
  getProductProfile,
  queryProductDetail,
  getRankingAndAnalysisStaticData,
} from "@/api/companyApi.js";
import gui_mark_total from "../../../../components/gui_mark_total/gui_mark_total.vue";

export default {
  name: "",
  // props: {},
  components: {
    ReLogin,
    gui_mark_total,
  },
  data() {
    return {
      data: {
        links: [],
        nodes: [],
      },
      RiskLoding: false,
      ExporttableData: [],
      activeIcon: false,
      nodes: [], //{ name: 'Climate change' }
      links: [],
      reLoginVis: false,
      Country: "",
      Importyear: "",
      companyList: [],
      Yearoptions: [],

      Countryoptions: [],
      countryOfImporter: [],
      countryOfSupplier: [],

      idMapImport: new Map(),
      idMapExport: new Map(),
      markTotalList: [],
      ImportCountries: "",
      ExportCountries: "",
      TopImportCompany: [],
      TopExportCompany: [],
    };
  },
  mounted() {
    this.getCompanySnaplist();
    this.getRankingAndAnalysisStaticDatalist();

    this.$store.dispatch("app/setTools", {
      name: "select",
      key: "isActive",
      value: false,
    });
    this.getProductSupplyChainFilterYear();
    this.$emit("UpdatamarkTotalList", true);

    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    getRankingAndAnalysisStaticDatalist() {
      getRankingAndAnalysisStaticData({
        tradeCode: this.$route.query.id3a,
        rankType: 1,
      }).then((res) => {
        if (res.code == 200) {
          var tradeProductRankTop5DTO = res.data.tradeProductRankTop5DTO;
          console.log(tradeProductRankTop5DTO);
          if (tradeProductRankTop5DTO) {
            this.TopImportCompany = tradeProductRankTop5DTO[0];
          }
        }
      });

      getRankingAndAnalysisStaticData({
        tradeCode: this.$route.query.id3a,
        rankType: 2,
      }).then((res) => {
        if (res.code == 200) {
          var tradeProductRankTop5DTO = res.data.tradeProductRankTop5DTO;
          console.log(tradeProductRankTop5DTO);
          if (tradeProductRankTop5DTO) {
            this.TopExportCompany = tradeProductRankTop5DTO[0];
          }
        }
      });
    },

    getCompanySnaplist() {
      const id3a = this.$route.query.id3a;
      console.log(88888);
      console.log(id3a);
      // 392690
      getProductProfile({
        hsCode: id3a,
      })
        .then((res) => {
          if (res.code == 200) {
            this.HsCodeObject = res.data;
            sessionStorage.setItem(
              "hsCodeDescription",
              this.HsCodeObject?.hsCodeDescription,
            );
            document.title = this.HsCodeObject?.hsCodeDescription;
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
      queryProductDetail({
        hsCode: id3a,
      })
        .then((res) => {
          if (res.code == 200) {
            this.markTotalList = [
              {
                name:  this.$t("SearchTrade.TotalImports"),
                num: res.data.importAmount,
              },
              {
                name: this.$t("SearchTrade.TotalExports"),
                num: res.data.exportAmount,
              },
              {
                name: this.$t("SearchTrade.TotalImportWeight"),
                num: res.data.importWeight,
              },
              {
                name: this.$t("SearchTrade.TotalExportWeight"),
                num: res.data.exportWeight,
              },
              {
                name: this.$t("SearchTrade.NumberofSuppliers"),
                num: res.data.numberOfSuppliers,
              },
              {
                name: this.$t("SearchTrade.NumberofBuyers"),
                num: res.data.numberOfBuyers,
              },
              {
                name: this.$t("SearchTrade.NumberofOriginCountries"),
                num: res.data.numberOfOrigins,
              },
              {
                name: this.$t("SearchTrade.NumberofDestinationCountries"),
                num: res.data.numberOfDestinations,
              },
            ];

            this.ImportCountries = res.data.numberOfOrigins;
            this.ExportCountries = res.data.numberOfDestinations;
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },

    resizeFn() {
      this.suppleEchart();
    },
    default() {},
    ChangCountry() {
      let CountryData = [];
      CountryData = this.Yearoptions.filter(
        (item) => item.year == this.Importyear,
      );
      this.Countryoptions = CountryData[0].countries;
      this.Country = this.Countryoptions[0].countryCode;
      this.getData();
    },
    getProductSupplyChainFilterYear() {
      getProductSupplyChainFilter({
        hsCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.Yearoptions = res.data;

          let arr = res.data.filter((item) => item.hasData == true);
          this.Importyear = arr[0].year;
          this.Country = arr[0].countries[0].countryCode;
          this.ChangCountry();
        } else {
          this.Yearoptions = [];
        }
      });
    },
    getData() {
      this.getProductSupplyChainTopTenCountriesList();

      this.RiskLoding = true;
      let existingChart = this.$echarts.getInstanceByDom(
        this.$refs.SupplyChainEchart,
      );
      if (existingChart) {
        existingChart.dispose(); // 销毁旧的实例
      }
      getProductSupplyChain({
        hsCode: this.$route.query.id3a,
        year: this.Importyear,
        countryCode: this.Country,
      })
        .then((result) => {
          // let data = JSON.parse(crypto.decrypt(result));
          let data = result;
          if (data.code == 200) {
            this.RiskLoding = false;
            const listNode = data.data.nodes;
            let arr = [];
            const listLinks = data.data.links;
            this.companyList = data.data.nodes;
            let arrLink = [];
            listNode.forEach((item) => {
              const pobj = {
                name: item.nameEn,
              };
              arr.push(pobj);
            });
            this.nodes = arr;

            listLinks.forEach((item, index) => {
              const obj = {
                source: item.sourceEn,
                target: item.targetEn,
                value: item.value,
              };
              arrLink.push(obj);
            });

            // this.linkpre = arrLink
            this.links = arrLink;
            this.idMapImport = new Map();
            this.links.forEach((item) => {
              if (!this.idMapImport.has(item.source)) {
                this.idMapImport.set(item.source, 1); // 初始化Import计数
              } else {
                this.idMapImport.set(
                  item.source,
                  this.idMapImport.get(item.source) + 1,
                ); // 增加Import计数
              }
            });
            this.idMapExport = new Map();
            this.links.forEach((item) => {
              if (!this.idMapExport.has(item.target)) {
                this.idMapExport.set(item.target, 1); // 初始化Export计数
              } else {
                this.idMapExport.set(
                  item.target,
                  this.idMapExport.get(item.target) + 1,
                ); // 增加Export计数
              }
            });

            // this.findLink()
            this.suppleEchart();
          } else {
            this.RiskLoding = false;
          }
        })
        .catch((err) => {
          this.RiskLoding = false;
          this.reLoginVis = String(err).includes("403");
        });
    },

    suppleEchart() {
      let that = this;

      if (this.echartsBox) {
        this.echartsBox.dispose();
      }
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);

      const option = {
        grid: {
          left: "0%", // 调整这个数值来控制图表在容器中的左侧位置
          // 其他 grid 相关设置
        },
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        series: [
          {
            type: "sankey",
            data: that.nodes,
            links: that.links,
            emphasis: {
              focus: "adjacency",
            },
            levels: [
              {
                depth: 0,
                itemStyle: {
                  color: "#fbb4ae",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 1,
                itemStyle: {
                  color: "#b3cde3",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 2,
                itemStyle: {
                  color: "#ccebc5",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 3,
                itemStyle: {
                  color: "#decbe4",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
            ],
            lineStyle: {
              curveness: 0.5,
            },
          },
        ],
      };
      this.echartsBox.setOption(option);
    },
    getProductSupplyChainTopTenCountriesList() {
      getProductSupplyChainTopTenCountries({
        hsCode: this.$route.query.id3a,
        year: this.Importyear,
        countryCode: this.Country,
      }).then((res) => {
        if (res.code == 200) {
          console.log(11111);
          console.log(res.data);

          this.countryOfSupplier = res.data.countryOfSupplier;
          this.countryOfImporter = res.data.countryOfImporter;
        } else {
          this.countryOfSupplier = [];
          this.countryOfImporter = [];
        }
      });
    },
    exportCompanyImport(item) {
      if (item.value != "") {
        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/details
          path:
            "/index/tradeCompany/Trade/" +
            item.code +
            "/tradeMap/map?id3a=" +
            item.code +
            "&companyName=" +
            item.value +
            "&Tradechannel=Company" +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
.operations-head {
  color: #009ea7;
}
.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

/deep/ .el-table td.el-table__cell {
  border-right: none;
  height: 3.71rem;
}

.Product_Supply_select {
  padding: 20px;
  background: #f5f5f5;
  border-radius: 4px;
}

.Information {
  width: 64px;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ownership-graph-left {
  height: auto;
  margin-right: 200px;
}
.ownership-graph-left-item {
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #cccccc;
}
.ownership-graph-left-item:first-child {
  border-top: 1px solid #cccccc;
}
.ownership-graph-left-name {
  width: 280px;
  height: 100%;
  padding-left: 20px;
  font-family: "Arial Bold";
  font-size: 18px;
  background: #f3f3f3;
}
.ownership-graph-left-desc {
  flex: 1;
  line-height: 22px;
  font-size: 18px;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ownership-graph-left-desc span {
}
.detail_echart_con_box {
  gap: 0;
}
.operations-box {
  flex: 1;
}
@media screen and (max-width: 1920px) {
  .operations-content {
    padding: 22px 30px;
  }

  .ownership-graph-left {
    margin-right: 140px;
  }
  .ownership-graph-left-item {
    height: 60px;
    line-height: 60px;
  }
  .ownership-graph-left-name {
    width: 200px;
    padding-left: 14px;
    font-size: 16px;
  }
  .ownership-graph-left-desc {
    line-height: 16px;
    font-size: 16px;
  }
  .detail_echart_con_box {
    gap: 0;
  }
}
@media screen and (max-width: 1439px) {
  .operations-content {
    padding: 20px 30px;
  }
}
</style>
